import {
    useEditorRef,
    useHotkeys,
    usePluginOption,
} from '@udecode/plate/react';

import { CitationPlugin } from '../../CitationPlugin';
import { submitFloatingCitation } from '../../transforms';

export const useFloatingCitationEnter = () => {
    const editor = useEditorRef();

    const open = usePluginOption(CitationPlugin, 'isOpen', editor.id);

    useHotkeys(
        '*',
        (e) => {
            if (e.key !== 'Enter') return;
            if (submitFloatingCitation(editor)) {
                e.preventDefault();
            }
        },
        {
            enabled: open,
            enableOnFormTags: ['INPUT'],
        },
        []
    );
};
